//
// WARNING
//
// this mixin can be only used on root component
//

import form from '../../form'
import toggleScroll from '../../toggle-scroll'

export default {
  data() {
    return {
      formStep: 0,
      showOverlay: false,
      currentPopup: '',
      currentVideo: '',
      gallery: [],
      iframe: '',
      currentContactPerson: null,
    }
  },
  methods: {
    togglePopup(enable) {
      if (enable === this.showOverlay) return
      toggleScroll(!enable, this.$refs.popup)
      this.showOverlay = enable
      if (enable) {
        this.formStep = 0
      }
    },
    handleKeyUp(e) {
      if (e.keyCode === 27) {
        this.closePopup()
      }
    },
    pickPopup(popupName, runFormInitializations = true) {
      this.currentPopup = popupName
      this.togglePopup(true)

      if (runFormInitializations) {
        setTimeout(() => {
          if (this.$refs[popupName]) {
            form(this.$refs[popupName])
          }
        }, 0)
      }
    },
    closePopup() {
      this.currentPopup = ''
      this.togglePopup(false)
    },
    tryNextStep() {
      const steps = this.$refs.steps
      const currentStep = steps.children[this.formStep]
      const inputs = Array.from(
        currentStep.querySelectorAll('input,select,textarea')
      )
      const allGood = inputs
        .map(el => el.checkValidity())
        .every(el => el === true)
      if (allGood) {
        this.formStep += 1
      }
    },
    openVideo(video) {
      this.currentVideo = video
      this.pickPopup('video')
    },
    openGallery(images, activeIndex = 0) {
      this.gallery = [
        ...images.slice(activeIndex),
        ...images.slice(0, activeIndex - 1),
      ]
      this.pickPopup('gallery')
    },
    openIframe(iframe) {
      this.iframe = iframe
      this.pickPopup('iframe')
    },
    openSendAMessage(contactPerson) {
      this.currentContactPerson = contactPerson
      this.pickPopup('send-a-message')
    },
  },
  mounted() {
    document.addEventListener('keyup', this.handleKeyUp)
  },
  beforeUnmount() {
    document.removeEventListener('keyup', this.handleKeyUp)
  },
  computed: {
    windowLocation() {
      return window.location
    },
  },
}
